import { FileArchive, FileImage, FileSpreadsheet, FileText, FileType2, Film, Folder, Presentation, Sheet } from "lucide-react";

import { getMimeCategory } from "@/lib/utils";

interface FileIconProps {
  mimeType?: string;
  fileName?: string;
  isFolder?: boolean;
  className?: string;
}

export function FileIcon({ mimeType, fileName, isFolder = false, className }: FileIconProps) {
  if (isFolder) {
    return <Folder className={className} />;
  }

  switch (getMimeCategory(mimeType, fileName)) {
    case "image":
      return <FileImage className={className} />;
    case "video":
      return <Film className={className} />;
    case "pdf":
      return <FileType2 className={className} />;
    case "spreadsheet":
      return <FileSpreadsheet className={className} />;
    case "document":
      return <FileText className={className} />;
    case "presentation":
      return <Presentation className={className} />;
    default:
      return <FileArchive className={className} />;
  }
}
